module.exports = __webpack_public_path__ + "img/code-review.57f6b2d0.jpg";